interface localItem {
    [key: string]: string | number;
}
interface localList {
    [key: string]: localItem[];
}

// 多语言--针对全局能用--后面2个必须大写
export const langeMap: any = {
    // en: 'en',
    zh: 'zh-CN',
    ja: 'ja-JP',
    kr: 'ko-KR',
    es: 'es-ES',
    de: 'de-DE',
    it: 'it-IT',
    nl: 'nl-NL',
    fr: 'fr-FR',
    eu: 'en-EU',
    uk: 'en-UK',
    us: 'en-US',
    ru: 'ru-RU',
    cis: 'ru-RU',
    tw: 'zh-TW',
    br: 'pt-BR',
    mx: 'es-MX',
    ph: 'en-PH',
};

// 多语言--针对全局能用--后面2个必须大写
export const appLocaleMap: any = {
    // en: 'en',
    cn: 'zh_CN',
    jp: 'ja_JP',
    de: 'de_DE',
    fr: 'fr_FR',
    eu: 'en_US',
    nl: 'nl_NL',
    uk: 'en_US',
    us: 'en_US',
    ca: 'en_US',
    au: 'en_US',
    tw: 'zh_TW',
    br: 'pt_BR',
    mx: 'es_MX',
    ph: 'en_PH',
};

// 未添加的语言属性，默认使用 en 的
export const localsList: localList = {
    northAmerica: [
        {
            local: 'ca',
            alia: 'en',
            region: 'Canada',
            regionText: 'Canada',
            language: 'English',
            languageText: 'English',
            appId: 4,
            acceptLanguage: 'en-CA,en;q=0.9',
        },
        {
            local: 'us',
            alia: 'en',
            region: 'United States',
            regionText: 'United States',
            language: 'English',
            languageText: 'English',
            appId: 1,
            acceptLanguage: 'en-US,en;q=0.9',
        },
    ],
    europe: [
        {
            local: 'eu',
            alia: 'eu',
            region: 'Europe',
            regionText: 'Europe',
            language: 'English',
            languageText: 'English',
            appId: 9,
            acceptLanguage: 'en-EU,en;q=0.9',
        },
        {
            local: 'fr',
            alia: 'fr',
            region: 'France',
            regionText: 'France',
            language: 'French',
            languageText: 'français',
            appId: 6,
            acceptLanguage: 'fr-FR,fr;q=0.9',
        },
        {
            local: 'de',
            alia: 'de',
            region: 'Germany',
            regionText: 'Deutschland',
            language: 'German',
            languageText: 'Deutsch',
            appId: 7,
            acceptLanguage: 'de-DE,de;q=0.9',
        },
        {
            local: 'it',
            alia: 'it',
            region: 'Italy',
            regionText: 'Italia',
            language: 'Italian',
            languageText: 'Italian',
            appId: 13,
            acceptLanguage: 'it-IT,it;q=0.9',
        },
        {
            local: 'nl',
            alia: 'nl',
            region: 'Netherlands',
            regionText: 'Nederland',
            language: 'Dutch',
            languageText: 'Nederlands',
            appId: 14,
            acceptLanguage: 'nl-NL,nl;q=0.9',
        },
        {
            local: 'es',
            alia: 'es',
            region: 'Spain',
            regionText: 'España',
            language: 'Spain',
            languageText: 'Español',
            appId: 11,
            acceptLanguage: 'es-ES,es;q=0.9',
        },
        {
            local: 'uk',
            alia: 'en',
            region: 'United Kingdom',
            regionText: 'United Kingdom',
            language: 'English',
            languageText: 'English',
            appId: 2,
            acceptLanguage: 'en-UK,en;q=0.9',
        },
        {
            // 克罗地亚
            local: 'hr',
            alia: 'hr',
            region: 'Republika Hrvatska',
            regionText: 'Republika Hrvatska',
            language: 'Hrvatski',
            languageText: 'Hrvatski',
        },
        {
            // 捷克
            local: 'cz',
            alia: 'cz',
            region: 'Česká republika',
            regionText: 'Česká republika',
            language: 'český jazyk',
            languageText: 'český jazyk',
        },
        {
            // 丹麦
            local: 'dk',
            alia: 'dk',
            region: 'Danmark',
            regionText: 'Danmark',
            language: 'Dansk',
            languageText: 'Dansk',
        },
        {
            // 格鲁吉亚
            local: 'ge',
            alia: 'ge',
            region: 'Georgia',
            regionText: 'საქართველო',
            language: 'Georgian',
            languageText: 'ქართული',
            appId: 24,
            acceptLanguage: 'ka-GE,ka;q=0.9',
        },
        {
            // 爱尔兰
            local: 'ie',
            alia: 'ie',
            region: 'Ireland',
            regionText: 'Ireland',
            language: 'English',
            languageText: 'English',
        },
        {
            // 希腊
            local: 'gr',
            alia: 'gr',
            region: 'Ελληνική Δημοκρατία',
            regionText: 'Ελληνική Δημοκρατία',
            language: 'Ελληνικά',
            languageText: 'Ελληνικά',
        },
        {
            // 挪威
            local: 'no',
            alia: 'no',
            region: 'Norge',
            regionText: 'Norge',
            language: 'Norsk',
            languageText: 'Norsk',
        },
        {
            // 波兰
            local: 'pl',
            alia: 'pl',
            region: 'Polska',
            regionText: 'Polska',
            language: 'Polski',
            languageText: 'Polski',
            acceptLanguage: 'pl-PL,pl;q=0.9',
        },
        {
            // 葡萄牙
            local: 'pt',
            alia: 'pt',
            region: 'Portugal',
            regionText: 'Portugal',
            language: 'Portuguese',
            languageText: 'Portuguese',
        },
        {
            // 斯洛文尼亚
            local: 'si',
            alia: 'si',
            region: 'Republika Slovenija',
            regionText: 'Republika Slovenija',
            language: 'Slovenščina',
            languageText: 'Slovenščina',
        },
        {
            // 瑞典
            local: 'se',
            alia: 'se',
            region: 'Sverige',
            regionText: 'Sverige',
            language: 'svenska',
            languageText: 'svenska',
            acceptLanguage: 'sv-SE,sv;q=0.9',
        },
        {
            // 瑞士
            local: 'ch',
            alia: 'ch',
            region: 'Schweiz',
            regionText: 'Schweiz',
            language: 'Deutsch',
            languageText: 'Deutsch',
            acceptLanguage: 'de-CH,de;q=0.9',
        },
        {
            // 土耳其
            local: 'tr',
            alia: 'tr',
            region: 'Türkiye',
            regionText: 'Türkiye',
            language: 'Turkish',
            languageText: 'Turkish',
        },
        {
            // 哈萨克斯坦
            local: 'kz',
            alia: 'kz',
            region: 'Республика Казахстан',
            regionText: 'Республика Казахстан',
            language: 'Казахский и русский',
            languageText: 'Казахский и русский',
        },
    ],
    asiaPacific: [
        {
            local: 'au',
            alia: 'en',
            region: 'Australia',
            regionText: 'Australia',
            language: 'English',
            languageText: 'English', // chooseSite 页面展示使用
            appId: 3,
            acceptLanguage: 'en-AU,en;q=0.9',
        },
        {
            local: 'cn',
            alia: 'zh',
            region: 'China',
            regionText: '中国（大陆）',
            language: 'Chinese',
            languageText: '简体中文',
            appId: 10,
            acceptLanguage: 'zh-CN,zh;q=0.9', //暂定
        },
        {
            local: 'jp',
            alia: 'ja',
            region: 'Japan',
            regionText: '日本',
            language: 'Japanese',
            languageText: '日本語',
            appId: 5,
            acceptLanguage: 'ja-JP,ja;q=0.9',
        },
        {
            // 菲律宾
            local: 'ph',
            alia: 'en',
            region: 'Philippines',
            regionText: 'Philippines',
            language: 'English',
            languageText: 'English',
            appId: 25,
            acceptLanguage: 'en-PH,en;q=0.9',
        },
        {
            local: 'tw',
            alia: 'zh',
            region: '中國台灣',
            regionText: '中國台灣',
            language: 'Chinese',
            languageText: '繁体中文',
            appId: 19,
            acceptLanguage: 'zh_TW,zh;q=0.9',
        },
        {
            // 韩国
            local: 'kr',
            alia: 'kr',
            region: '대한민국',
            regionText: '대한민국',
            language: '한국어',
            languageText: '한국어',
            appId: 8,
            acceptLanguage: 'ko-KR,ko;q=0.9',
        },
        {
            // 印度
            local: 'in',
            alia: 'in',
            region: 'India',
            regionText: 'India',
            language: 'अंग्रेज़ी',
            languageText: 'अंग्रेज़ी',
        },
        {
            // 印尼
            local: 'id',
            alia: 'id',
            region: 'Indonesia',
            regionText: 'Indonesia',
            language: 'Bahasa Indonesia',
            languageText: 'Bahasa Indonesia',
        },
        {
            // 马来西亚
            local: 'my',
            alia: 'my',
            region: 'Malaysia',
            regionText: 'Malaysia',
            language: 'Malaysia',
            languageText: 'Malaysia',
        },
        {
            // 新西兰
            local: 'nz',
            alia: 'nz',
            region: 'New Zealand',
            regionText: 'New Zealand',
            language: 'English',
            languageText: 'English',
        },
        {
            // 新加坡
            local: 'sg',
            alia: 'sg',
            region: 'Singapore',
            regionText: 'Singapore',
            language: 'Singapore',
            languageText: 'Singapore',
        },
        {
            // 泰国
            local: 'th',
            alia: 'th',
            region: 'Thailand',
            regionText: 'Thailand',
            language: 'ภาษาไทย',
            languageText: 'ภาษาไทย',
        },
        {
            // 越南
            local: 'vn',
            alia: 'vn',
            region: 'Vietnam',
            regionText: 'Vietnam',
            language: 'tiếng Việt',
            languageText: 'tiếng Việt',
        },
    ],
    latin: [
        {
            // 墨西哥
            local: 'mx',
            alia: 'mx',
            region: 'Mexico',
            regionText: 'México',
            language: 'Spanish',
            languageText: 'Español',
            appId: 24,
            acceptLanguage: 'es-MX,es;q=0.9',
        },
        {
            // 阿根廷
            local: 'ar',
            alia: 'ar',
            region: 'Argentina',
            regionText: 'Argentina',
            language: 'español',
            languageText: 'español',
        },
        {
            local: 'br',
            alia: 'br',
            region: 'Brazil',
            regionText: 'Brasil',
            language: 'Portuguese',
            languageText: 'Português',
            appId: 18,
            acceptLanguage: 'pt-BR,br;q=0.9',
        },
        {
            // 智利
            local: 'cl',
            alia: 'cl',
            region: 'Chile',
            regionText: 'Chile',
            language: 'español',
            languageText: 'español',
        },
        {
            // 哥伦比亚
            local: 'co',
            alia: 'co',
            region: 'Colombia',
            regionText: 'Colombia',
            language: 'español',
            languageText: 'español',
        },
    ],
    africa: [
        {
            // 南非
            local: 'za',
            alia: 'za',
            region: 'South Africa',
            regionText: 'South Africa',
            language: 'English',
            languageText: 'English',
            appId: 15,
            acceptLanguage: 'en-ZA,en;q=0.9',
        },
        {
            // 沙特
            local: 'sa',
            alia: 'sa',
            region: 'المملكة العربية السعودية',
            regionText: 'المملكة العربية السعودية',
            language: 'العربية',
            languageText: 'العربية',
            appId: 16,
            acceptLanguage: 'sa-AR,sa;q=0.9',
        },
    ],
    global: [
        {
            local: 'global',
            alia: 'en',
            region: 'Global',
            regionText: 'Global',
            language: 'English',
            languageText: 'English',
            appId: 27,
            acceptLanguage: 'en-US,en;q=0.9',
        },
    ],
};

function getLocalsMap() {
    const temp: {
        [key: string]: {};
    } = {
        en: {
            local: 'en',
            alia: 'en',
            region: 'United States',
            regionText: 'United States',
            language: 'English',
            languageText: 'English',
            appId: 1,
            acceptLanguage: 'en-US,en;q=0.9',
        },
    };
    for (const value of Object.values(localsList)) {
        if (value.length > 0) {
            value.forEach((item) => {
                temp[item.local] = item;
            });
        }
    }
    return temp;
}

export const localValueMap = getLocalsMap();

// 获取文字图片后缀
export const getImageLocal = function (locale: string, arr: string[]) {
    if (locale === 'sa') locale = 'uk'; // 阿拉伯采用uk规格图片
    if (locale === 'cis' && arr.includes(locale)) {
        return 'ru';
    }
    if (arr.indexOf(locale) !== -1) return locale;
    return 'en';
};

// 获取外观规格图片后缀
export const getImageSpec = function (locale: string, arr: string[]) {
    const localeMapping: Record<string, string> = {
        sa: 'uk',
        de: 'eu',
        fr: 'eu',
        it: 'eu',
        es: 'eu',
        nl: 'eu',
        cis: 'eu',
        kr: 'eu',
    };
    if (locale in localeMapping) {
        return localeMapping[locale];
    } else if (arr.includes(locale)) {
        return locale;
    }
    // 默认情况下返回 'en'
    return 'en';
};

// 只有该语言【有】
export const onlyIncludesLocal = function (locale: string, arr: string[]) {
    if (arr.indexOf(locale) !== -1) return true;
    return false;
};

// 只有该语言【没有】
export const noneIncludesLocal = function (locale: string, arr: string[]) {
    if (arr.indexOf(locale) !== -1) return false;
    return true;
};
